import {observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class CargosMaisContratados10Store {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable detalhes;
    @observable departamentos;
    @observable cargoSelecionado;
    @observable activeTab;

    constructor() {
        this.indicadorService = new IndicadorService();

        this.activeTab = '1';
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        if(this.activeTab === '3') {
            this.toggle('1')
        }

        this.filtro = filtro;
        this.cargoSelecionado = null;
        this.detalhes = [];
        this.departamentos = [];

        this.indicadorService.findCargosMaisContratados10(filtro).then(response => {
            this.dados = response.data.map((cargo) => ({
                id: cargo.id,
                nome: cargo.cargo,
                "Quantidade": cargo.quantidade,
                "Percentual": cargo.percentual
            }));

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    detalharCargo = (cargo) => {
        this.carregando = true;
        this.erro = null;
        this.toggle('3')

        const filtro = { ...this.filtro, cargos: [ cargo.id ? cargo.id : -1 ] };

        this.cargoSelecionado = cargo.nome;

        this.indicadorService.findContratacaoDeterminadoCargoDivisaoDepartamento(filtro).then(response => {
            const divisoesAgrupadas = _.groupBy(response.data, (d) => d.divisao);
            const divisoes = Object.keys(divisoesAgrupadas);
            const departamentosAgrupados = _.groupBy(response.data, (d) => d.departamento);
            const departamentos = Object.keys(departamentosAgrupados);

            let dados = [];
            _.forEach(divisoes, (divisao) => {
                let dado = { nome: divisao };

                const divisoesDepartamentos = divisoesAgrupadas[divisao];

                _.forEach(divisoesDepartamentos, (divisaoDepartamento) => {
                    dado = { ...dado, [divisaoDepartamento.departamento]: divisaoDepartamento.quantidade };
                });

                dados = [ ...dados, dado ];
            });

            this.departamentos = departamentos;
            this.detalhes = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }
}
